module.exports = __webpack_public_path__ + "rotary_sharp_right.svg?ee9d0fd5437e39326654bb12ddd6b604";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_sharp_right.svg
// module id = 211
// module chunks = 0